import { useState } from 'react';

const PricingFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Ücretsiz plan süresiz mi?',
      answer: 'Evet, ücretsiz plan tamamen süresizdir. Herhangi bir kredi kartı bilgisi gerekmeden BAGA\'nın canlı karar yayın sayfasına erişebilir ve gerçek zamanlı kararları takip edebilirsiniz.',
    },
    {
      question: 'Pro plan ne zaman kullanıma açılacak?',
      answer: 'Pro plan şu anda geliştirme aşamasındadır. Bekleme listesine katılarak, Pro plan kullanıma açıldığında ilk haberdar olanlar arasında olabilir ve özel lansman indiriminden yararlanabilirsiniz.',
    },
    {
      question: 'Planlar arasında geçiş yapabilir miyim?',
      answer: 'Evet, Pro plan kullanıma açıldığında istediğiniz zaman ücretsiz plandan Pro plana geçiş yapabileceksiniz. Geçiş işlemi anında gerçekleşir ve tüm gelişmiş özelliklere hemen erişim sağlarsınız.',
    },
    {
      question: 'Ödeme yöntemleri nelerdir?',
      answer: 'Pro plan için kredi kartı, banka kartı ve havale/EFT ile ödeme yapabileceksiniz. Tüm ödemeler güvenli ödeme altyapısı üzerinden gerçekleştirilir.',
    },
  ];

  return (
    <section className="py-32 bg-dark relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-beige-light mb-6">
            Fiyatlandırma Hakkında SSS
          </h2>
          <p className="text-xl text-beige/70">
            Planlar ve ödemeler hakkında sık sorulan sorular
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-dark-card border border-dark-border rounded-xl overflow-hidden hover:border-emerald/30 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <h4 className="text-lg font-semibold text-beige-light pr-8">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-down-s-line text-2xl text-emerald transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-beige/70 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingFAQ;
